import { TGCTAs } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export const areValidCtas = (ctas?: TGCTAs[]) => {
    return !isEmpty(ctas?.[0]?.text) && !isEmpty(ctas?.[1]?.text);
};
